var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-container"},[_vm._t("status"),_c('h3',{style:({'color':_vm.textColor?_vm.textColor:'#666666'})},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.hideCTA)?[_c('div',{staticClass:"cta-empty"})]:[_vm._t("cta")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }